import { EXPERIMENT_VARIATION, SERP_LOAD_MORE } from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

const VARIATION_PER_PAGE: GenericRecord<number> = {
  [EXPERIMENT_VARIATION.V1]: 10,
  [EXPERIMENT_VARIATION.V2]: 20,
  default: 10,
}

const ENABLED_VARIANTS = new Set([
  EXPERIMENT_VARIATION.V1,
  EXPERIMENT_VARIATION.V2,
])

export const shouldModifyHitsPerPage = (experiments: Experiment[]): boolean => {
  if (!Array.isArray(experiments)) {
    return false
  }

  const experiment = getExperiment(SERP_LOAD_MORE, experiments)

  return (
    experiment.isEnabled &&
    ENABLED_VARIANTS.has(<EXPERIMENT_VARIATION>experiment.variant)
  )
}

export const getHitsPerPage = (experiments: Experiment[]): number | null => {
  if (!Array.isArray(experiments)) {
    return null
  }

  const experiment = getExperiment(SERP_LOAD_MORE, experiments)
  if (shouldModifyHitsPerPage(experiments)) {
    return VARIATION_PER_PAGE[experiment.variant] || VARIATION_PER_PAGE.default
  }

  return null
}
